import { useEffect } from 'react';

export function useCloseBrowserWarning(shouldWarnOnClose: boolean) {
  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      e.preventDefault();
    };

    if (!shouldWarnOnClose) {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      return;
    }

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [shouldWarnOnClose]);
}
